export enum FeatureFlagDictionaryEnum {
  ZIP_CODE_FLAG = 'ZipcodeEnabled',
  CVV_FLAG = 'CVVEnabled',
  ENABLE_RESOURCE_BUNDLE_MOCK = 'enable_resource_bundle_mock',
  DISPLAY_CONTEXTUAL_HELP_TRAVEL_DOCS = 'display-contextual-help-travel-docs',
  CRUISE_SURVEY = 'isNewToCruiseSurveyEnabled',
  MESSAGING_CENTER = 'isMessagingCenterEnabled',
  ENABLE_COBRAND_INDICATOR_BOARDING_PASS = 'enableCobrandIndicatorBoardingPass',
  ENABLE_COBRAND_TRANSFORMATION_PROGRAM = 'enableCobrandTransformationProgram',
  ENABLE_COBRAND_NEW_PROGRAM_PROMPTS = 'enableCobrandNewProgramPrompts',
  ENABLE_COBRAND_KODDI_ADS = 'enableCobrandKoddiAds',
  CRUISE_CONTRACT_COUNTRY_RESIDENCE = 'olci-ctc-source',
  NEW_GA_DASHBOARD_ENABLED = 'newGADashboardEnabled',
}
